import { createTheme } from "@material-ui/core/styles";

export const theme1 = createTheme({
  palette: {
    menu: {
      backgroundColor: "#F0F8FF",
      activeColor: "#2B65EC",
      color: "#808080",
      activeBorder: "6px",
      paddingLeft: "10px",
    },
    menuIcon: {
      fontSize: "30px",
    },
  },
});
